import React, { useEffect, useState } from "react";
import StepsProgress from "./StepsProgress";
import PersonalForm from "./PersonalForm";
import EducationInfo from "./EducationInfo";
import WorkInFormation from "./WorkInformation";
import BankInformation from "./BankInformation";
import { Form, message } from "antd";
import moment from "moment";
import { CALL_API } from "common/API";
import Location from "./Location";

function AddUser() {
  const [step, setStep] = useState(0);
  const [showLoader, toggleLoader] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [form] = Form.useForm();
  const [signUniqueId, setSignUniqueId] = useState("");
  const [clientId, setClientId] = useState("");
  const [countrycode, setcountrycode] = useState("");

  console.log("formvalues--->", formValues);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("clientid");
    setClientId(id);
  }, []);

  const stepdata = [
    { id: 1, title: "" },
    { id: 2, title: "" },
    { id: 3, title: "" },
  ];

  const goBack = () => {
    setStep(step - 1);
  };

  const handlesubmit = async (roleId, roleName) => {
    try {
      toggleLoader(true);

      const {
        user_id,
        password,
        gender,
        date_of_birth,
        nationality,
        start_date,
        address,
        phone,
        overtime,
        salary,
        selectedRoleId,
        institute_Name,
        degree,
        specialization,
        company_Name,
        job_Title,
        relevent,
        employee_status,
        marital_status,
        employee_sponser,
        description,
        emergencycontactname,
        emergencycontactnumber,
        employementtype,
        bandid,
        usertimezone,
        salutation,
        initial,
        firstname,
        lastname,
        nssf,
        national_id,
        educationdetails,
        professionalcertifications,
        workexperience,
        practicaltrainings,
        probationstartdate,
        probationenddate,
        contractstartdate,
        contractenddate,
        reportingmanager,
      } = formValues;

      console.log("formvalues--->,", formValues);

      let userId = form.getFieldValue("user_id");
      let splitUserId = userId.split("@");
      let userIdWithoutDomain = splitUserId[0];
      // let updatedUserId = userIdWithoutDomain + storeId;
      const dobDate = new Date(date_of_birth);
      const workstartDate = new Date(start_date);
      const currentDate = new Date();
      const agecalculte = currentDate.getFullYear() - dobDate.getFullYear();
      // const bandNameList = bandList?.filter((item) => item?.bandId === bandid);

      const workexperienceDetails = form
        .getFieldValue("workexperience")
        ?.map((item) => {
          const { fromdate, todate, ...rest } = item;
          const formattedFromDate = moment(fromdate).format("YYYY-MM-DD");
          const formattedToDate = moment(todate).format("YYYY-MM-DD");
          return {
            ...rest,
            fromdate: formattedFromDate,
            todate: formattedToDate,
          };
        });

      const transformedEducationDetails = educationdetails?.map((item) => {
        const { attachment, fromdate, todate, ...rest } = item;
        const formattedFromDate = moment(fromdate).format("YYYY-MM-DD");
        const formattedToDate = moment(todate).format("YYYY-MM-DD");
        const updatedAttachment = attachment?.map((att) => ({
          name: att?.name,
          uniqueId: att?.response?.uniqueId,
        }));
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
          attachment: updatedAttachment,
        };
      });

      const practicaltrainingsDetails = practicaltrainings?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const formattedFromDate = moment(fromdate).format("YYYY-MM-DD");
        const formattedToDate = moment(todate).format("YYYY-MM-DD");
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        };
      });
      const professionalcertificationsDetails = professionalcertifications?.map(
        (item) => {
          const { attachment, fromdate, todate, ...rest } = item;
          const formattedFromDate = moment(fromdate).format("YYYY-MM-DD");
          const formattedToDate = moment(todate).format("YYYY-MM-DD");
          const updatedAttachment = attachment?.map((att) => ({
            name: att?.name,
            uniqueId: att?.response?.uniqueId,
          }));
          return {
            ...rest,
            fromdate: formattedFromDate,
            todate: formattedToDate,
            attachment: updatedAttachment,
          };
        },
      );

      const response = await CALL_API(`add-users/${clientId}`, "post", {
        user_id: user_id?.toLowerCase(),
        full_name: `${firstname} ${lastname}`,
        password: password,
        start_date: workstartDate
          ? moment(workstartDate).format("YYYY-MM-DD")
          : "",
        dateofbirth: dobDate ? moment(dobDate).format("YYYY-MM-DD") : "",
        gender: gender,
        age: agecalculte,
        maritalstatus: marital_status,
        nationality: nationality,
        role_id: [roleId],
        bandname: "",
        bandid: bandid,
        employementtype: employementtype ? employementtype : "",
        role_name: [roleName],
        institutename: institute_Name,
        degree: degree,
        specialization: specialization,
        yearofcompletion: formValues?.year_of_completion
          ? moment(formValues?.year_of_completion?._d).format("YYYY-MM-DD")
          : "",
        companyname: company_Name,
        jobtitle: job_Title,
        professionalsince: formValues?.professional_since
          ? moment(formValues?.professional_since._d).format("YYYY-MM-DD")
          : "",
        hireddate: formValues?.hired_date
          ? moment(formValues?.hired_date._d).format("YYYY-MM-DD")
          : "",
        relevant: relevent,
        employeesponser: employee_sponser,
        statusname: employee_status,
        jobdescription: description,
        status_id: "2",
        staff_department_id: "",
        overtime_status: overtime,
        salary: salary ? salary : "",
        address: address,
        phoneno: phone,
        profile_url: null,
        presentaddress: address,
        permanentaddress: address,
        emergencycontactname: emergencycontactname,
        emergencycontactnumber: emergencycontactnumber,
        baselocationid: "",
        basedepartmentid: "",
        usertimezone: usertimezone,
        salutation: salutation,
        initial: initial,
        firstname: firstname,
        lastname: lastname,
        nssf: nssf,
        national_id: national_id,
        educationdetails: transformedEducationDetails,
        professionalcertifications: professionalcertificationsDetails,
        workexperience: workexperienceDetails,
        practicaltrainings: practicaltrainingsDetails,
        reportingmanager: reportingmanager,
        probationstartdate: probationstartdate
          ? moment(probationstartdate?._d).format("YYYY-MM-DD")
          : "",
        probationenddate: probationenddate
          ? moment(probationenddate?._d).format("YYYY-MM-DD")
          : "",
        contractstartdate: contractstartdate
          ? moment(contractstartdate?._d).format("YYYY-MM-DD")
          : "",
        contractenddate: contractenddate
          ? moment(contractenddate?._d).format("YYYY-MM-DD")
          : "",
      });

      toggleLoader(false);
      setStep(0);
      form.resetFields();
      setFormValues({});
      setcountrycode("");

      if (response.code === "SUCCESS") {
        if (response?.message === "Please Upgrade Your Plan") {
          message.error(response?.message);
        } else {
          message.success("Submitted Successfully");
          // handlePermissionSubmit();
        }
      } else {
        message.error("Something went wrong");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div>
      <StepsProgress stepdata={stepdata} title="" step={step} />
      {step === 0 && (
        <PersonalForm
          setStep={setStep}
          setFormValues={setFormValues}
          formValues={formValues}
          form={form}
          countrycode={countrycode}
          setcountrycode={setcountrycode}
        />
      )}
      {/* {step === 1 && <Location setStep ={setStep} setFormValues={setFormValues} formValues={formValues} form={form}/>} */}
      {step === 1 && (
        <EducationInfo
          goBack={goBack}
          setStep={setStep}
          setFormValues={setFormValues}
          formValues={formValues}
          form={form}
          clientId={clientId}
        />
      )}
      {step === 2 && (
        <WorkInFormation
          goBack={goBack}
          setStep={setStep}
          setFormValues={setFormValues}
          formValues={formValues}
          form={form}
          handleSubmit={handlesubmit}
          showLoader={showLoader}
          clientId={clientId}
        />
      )}
      {/* {step === 4 && <BankInformation goBack={goBack} setFormValues={setFormValues}  handleSubmit={handleSubmit} formValues={formValues} form={form} showLoader={showLoader} setSignUniqueId={setSignUniqueId}/>} */}
    </div>
  );
}

export default AddUser;
